import { useParams } from "react-router-dom";
import { useTeamProfile } from "../../api/teamprofile/queryHooks";
import { decodeId, get_media_url } from "../../api/utils";
import { getAppFunctionForStaticButtons } from "../../components/topbanner";

const TeamprofileDetail = ({ data }) => {
  return (
    <div className="h-[75px] w-full px-[15px] flex items-end">
      <div>
        <img
          alt="profileimage"
          src={get_media_url(data.team_dp)}
          className="w-[75px] h-[75px] rounded-full border"
        />
      </div>
      <div className="ml-[15px] mb-2">
        <div className="text-base lg:text-xl">{data.team_title}</div>
        {/* <div className="text-xs flex items-center justify-between">
          <p>10.1 M Fans</p>
          <div className="h-[15px] border-l mx-4"></div>
          <p>256k Followings</p>
        </div> */}
        <button onClick={getAppFunctionForStaticButtons} className="mt-1 text-sm bg-gradient-to-r from-pinkish to-purpleish max-w-fit px-5 py-1 rounded-2xl">
          Join
        </button>
      </div>
    </div>
  );
};

const TeamprofileCard = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading, isError } = useTeamProfile(id);

  if (isError) return null;

  if (isLoading)
    return (
      <div>
        <div className="h-[210px] sm:h-[320px] md:h-[420px] lg:h-[30vh] relative w-full skeleton"></div>
      </div>
    );

  return (
    <div className="mb-3">
      <div className="h-[210px] sm:h-[320px] md:h-[420px] lg:h-[30vh] relative">
        <img
          className="w-full h-full object-cover"
          src={get_media_url(data.data.team_cover)}
          alt="team_cover"
        />
        <div
          className="absolute bottom-0 bg-black h-[83px] w-full bg-gradient-to-t"
          style={{
            background: "linear-gradient(to top, #00000099, #00000000)",
          }}
        ></div>
        <div className="absolute bottom-2 w-full flex justify-center">
          <TeamprofileDetail data={data.data} />
        </div>
      </div>
    </div>
  );
};

export default TeamprofileCard;
